import React, { ChangeEvent } from 'react';
import { CloseCircle, SearchAlternative } from '@td-client-frontend/icons';
import { FieldWrapper } from './form-controls';
import clsx from 'clsx';

interface SearchInputProps {
  searchValue: string;
  onChange: (x: string) => void;
  label?: string;
  name?: string;
  placeholder?: string;
  inputClasses?: string;
  isError?: boolean;
  leftWrapperClasses?: string;
  rightWrapperClasses?: string;
  wrapperClassName?: string;
  searchInputWrapperClasses?: string;
  closeCircleClasses?: string;
  fieldLabelClasses?: string;
  additionalLabelClasses?: string;
  labelClasses?: string;
}

export const SearchInput = ({
  searchValue,
  onChange,
  label = 'Search',
  name = 'searchInput',
  placeholder = 'search',
  isError,
  leftWrapperClasses,
  rightWrapperClasses,
  inputClasses,
  wrapperClassName,
  searchInputWrapperClasses,
  closeCircleClasses,
  fieldLabelClasses,
  labelClasses = 'text-lg leading-5 text-gray-60 mb-2'
}: SearchInputProps) => {
  const searchValueHandler = (event: ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value);
  };

  const resetInputValue = () => {
    onChange('');
  };

  const defaultClasses = 'shrink flex items-center justify-center h-full p-2';

  return (
    <div className={clsx('flex flex-col', searchInputWrapperClasses)}>
      <FieldWrapper
        label={label}
        name={name}
        labelClasses={labelClasses}
        fieldLabelClasses={fieldLabelClasses}
        skipError
      >
        <div
          className={clsx(
            'relative flex items-center justify-center field-with-icons h-10 bg-white',
            isError && 'shadow-field-error',
            wrapperClassName
          )}
        >
          <div className={clsx(defaultClasses, leftWrapperClasses)}>
            <SearchAlternative className='fill-gray-25' aria-hidden width={14} height={14} />
          </div>
          <input
            type='text'
            className={clsx('form-field border-0 focus:border-0 p-0 h-full', inputClasses)}
            autoComplete='off'
            name={name}
            placeholder={placeholder}
            value={searchValue}
            onChange={searchValueHandler}
            data-testid={`searchInput-${name}`}
          />
          <div className={clsx(defaultClasses, rightWrapperClasses)}>
            <button onClick={resetInputValue} data-testid='clearButton'>
              {searchValue && (
                <CloseCircle
                  className={clsx('stroke-current stroke-2 fill-gray-25 cursor-pointer', closeCircleClasses)}
                  width={16}
                  height={16}
                />
              )}
            </button>
          </div>
        </div>
      </FieldWrapper>
    </div>
  );
};
